<!-- TODO: this needs to become a dialog with rate card using new design -->
<template lang="html">
  <StandardDialog
    :title='title'>
    <template #activator=" { on } ">
      <slot name='activator' :on='on'>
        <v-btn v-on='on' dark>Activator</v-btn>
      </slot>
    </template>
    <template #main>
      <StandardForm
        :value="value"
        @input="$emit('input', $event)">
        <v-container fill-height fluid grid-list-xl>
          <v-layout justify-center wrap>
            <slot name='input'>
              <p>add inputs to this form</p>
            </slot>
          </v-layout>
        </v-container>
      </StandardForm>
    </template>
    <template #actions=" { deactivate } ">
      <slot name='actions' :deactivate='deactivate'>
        <v-btn color='success' v-on='deactivate'> Close </v-btn>
      </slot>
    </template>
  </StandardDialog>
</template>

<script>
import StandardDialog from '@/components/busie/StandardDialog';
import StandardForm from '@/components/busie/StandardForm';

export default {
  components: {
    StandardDialog,
    StandardForm
  },
  props: {
    title: {
      type: String,
      default: 'Edit Rate'
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
    }
  },
}
</script>

<style lang="css" scoped>
</style>
